import * as Yup from "yup";

const ActictyValiDation = Yup.object().shape({
    capacity: Yup.number()
        .required('Please enter capacity')
});


export default ActictyValiDation;
